import { render, staticRenderFns } from "./EventsDirectory.vue?vue&type=template&id=72deec50"
import script from "./EventsDirectory.vue?vue&type=script&lang=js"
export * from "./EventsDirectory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projects\\MDA\\schoolofmusic-ucla\\web\\app\\themes\\ucla\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72deec50')) {
      api.createRecord('72deec50', component.options)
    } else {
      api.reload('72deec50', component.options)
    }
    module.hot.accept("./EventsDirectory.vue?vue&type=template&id=72deec50", function () {
      api.rerender('72deec50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/EventsDirectory.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/EventsDirectory.vue
// module id = 295
// module chunks = 0